var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"card section bg-white rounded-md opacity-100 md:px-2"},[(_vm.title)?_c('div',{staticClass:"card-header py-5 px-8 rounded-t-md bg-cloud-dk leading-none text-lg"},[_c('VinTitle',{attrs:{"text":_vm.title}})],1):_vm._e(),_c('div',{staticClass:"card-body rounded-b-md px-8 py-6"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }